var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-title',{attrs:{"titleText":_vm.pageTitle}}),_c('client-form',{attrs:{"formType":_vm.formType,"client":_vm.client},on:{"setClient":_vm.createClientAccount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }